import { configureStore } from '@reduxjs/toolkit';
import emailsReducer from '../emailsSlice';

export const store = configureStore({
    reducer: {
        emails: emailsReducer,
        // add any other reducers here
    },
});

// Export types if you need them
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
